import { Box, VStack, HStack, Skeleton, Text } from '@chakra-ui/react';
import ColoredDotsDescription from '../../ColoredDotsDescription';
import { TRENDS_CHART_DOMAINS_LIST, WELLNESS_DOMAINS_DISPLAY_LABELS } from '@/constants';
import { CHART_COLORS_ARRAY } from '@/constants/ui';

const TrendsChartSkeleton = () => {
  return (
    <Box borderRadius="20px" w="full">
      <VStack align="start" spacing="24px" w="full">
        {/* Header */}
        <HStack w="full" justify="space-between" align="start">
          <VStack align="start" spacing="2">
            <Text variant="loraSectionTitle" textAlign="start">
              Wholeness Trends
            </Text>
            <Text variant={'urbanistMedium'} color={'text.mediumGray'}>
              Historical data of domain score averages per month.
            </Text>
          </VStack>
          <Skeleton height="54px" width="290px" borderRadius="8px" />
        </HStack>

        {/* Chart area */}
        <Box w="full" h="400px" position="relative">
          {/* Background shimmer to represent chart area */}
          <Skeleton position="absolute" inset="0" startColor="gray.100" endColor="gray.200" borderRadius="12px" />
          {/* Overlay of multiple line placeholders */}
          {Array.from({ length: 5 }).map((_, i) => (
            <Box
              key={i}
              position="absolute"
              top={`${15 + i * 10}%`}
              left="0"
              right="0"
              height="2px"
              bg="gray.300"
              opacity={0.6 - i * 0.1}
              transform={`skewX(${(i - 2) * 3}deg)`}
            />
          ))}
          {/* X-axis month markers */}
          <HStack position="absolute" bottom="8px" left="20px" right="20px" justify="space-between">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} height="3" width="25px" />
            ))}
          </HStack>
        </Box>
      </VStack>
      <HStack width={'full'} justifyContent={'center'} marginTop={'40px'}>
        <ColoredDotsDescription
          dots={TRENDS_CHART_DOMAINS_LIST.map((domain, i) => ({
            color: CHART_COLORS_ARRAY[i],
            description: WELLNESS_DOMAINS_DISPLAY_LABELS[domain],
          }))}
          dotsGap="20px"
        />
      </HStack>
    </Box>
  );
};

export default TrendsChartSkeleton;
